import { Component, HostBinding, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { WorkOrderService } from 'src/services';
import { NgForm } from '@angular/forms';
import { AppUtils, RoleMatrix } from 'src/helpers';
import { WorkOrderCategoryAddModel } from 'src/models';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-comp-wo-category-add',
    templateUrl: './company.wo.category.add.component.html'
})
export class CompanyWoCategoryAddComponent implements OnInit {
    companyId: number;
    @HostBinding('class.full_width') full_width = true;
    @BlockUI('container-blockui-add-category') blockUI: NgBlockUI;

    model: WorkOrderCategoryAddModel = new WorkOrderCategoryAddModel();
    roleMatrix: RoleMatrix;
    priorityList: any;

    constructor(private toastr: ToastrService,
        private router: Router,
        private route: ActivatedRoute,
        private appUtils: AppUtils,
        private workOrderService: WorkOrderService
    ) {

        this.roleMatrix = new RoleMatrix();
        this.priorityList = this.appUtils.getPriorityList()
        this.companyId = this.route.snapshot.params['companyId'];
        this.model.companyId = this.companyId;
    }

    ngOnInit(): void {
        if (!this.roleMatrix.is10FedUser && this.roleMatrix.companyId !== this.companyId.toString()) {
            this.router.navigate(['/error/404']);
        }
    }

    submit(f: NgForm) {
        if (this.model.dueDateDuration && (this.model.dueDateDuration < 1 || this.model.dueDateDuration > 365)) {
            f.form.controls['dueDateDuration'].setErrors({ 'range': true });
        } else {
            f.form.controls['dueDateDuration'].setErrors(null);
        }

        if (f.form.invalid) {
            return;
        }

        this.blockUI.start();
        this.workOrderService.addLocalCategory(this.model)
            .subscribe(
                () => {
                    setTimeout(() => {
                        this.router.navigate(['/work-order-comp-categories', this.companyId], { queryParams: { activeTab: 2 } });
                    }, 10);
                    setTimeout(() => {
                        this.toastr.success('Category has been added successfully.');
                    }, 500);
                },
                error => {
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                },
                () => {
                    this.blockUI.stop();
                });
    }
}
